import React from 'react';

import { UserRole, UserRoleValue } from '../UserRole';
import { generateUserRole, getRoleValueHandler } from '../Helpers';

import localStorage from '../LocalStorage';
import LocalizedStrings from 'react-localization';
import { translations } from '../../Common/Translations';
let strings = new LocalizedStrings(translations);
strings.setLanguage(localStorage.getFromStorage('lang'));


export class EditRoleSelect extends React.Component {
    
    generateSelect = () => {
        let isDisabled = false,
            selectedRoleValue = getRoleValueHandler(this.props.placeholder);

        if (localStorage.getUsernameRole() === UserRole.PHARMACY_MANAGER) {
            isDisabled = true;
        }
      
        return (
            <select onChange={this.props.handler} disabled={isDisabled} value={selectedRoleValue}>
                {isDisabled ? <option value={getRoleValueHandler(this.props.userDetails.role)}>{strings.ROLE_PHARMACIST}</option> : null}
                <option value="">{strings.role_select_placeholder}</option>
                {(generateUserRole(this.props.status) || []).map(role => {
                    return (
                        <option key={role.value} value={role.value}>
                            {strings[role.value]}
                        </option>
                    );
                })}
            </select>
        );
    };

    render() {
        return (
            <div className={`formSelect ${this.props.extraClasses}`}>
                <label>{this.props.label}</label>
                <div className="selectWrapper">{this.generateSelect()}</div>
            </div>
        );
    }
}

export class EditCompanyAdminSelect extends React.Component {
    generateSelect = () => {
        let listOfCompanies = this.props.companyList;
        return (
            <select onChange={this.props.handler} value={this.props.companyId}>
                <option value="">{strings.select_company}</option>
                {(listOfCompanies || []).map(company => {
                    return (
                        <option key={company.id} value={company.id}>
                            {company.name}
                        </option>
                    );
                })}
            </select>
        );
    };
    render() {
        return (
            <div className={`formSelect ${this.props.extraClasses}`}>
                <label>{this.props.label}</label>
                <div className="selectWrapper">{this.generateSelect()}</div>
            </div>
        );
    }
}

export class EditCompanyOwnerSelect extends React.Component {
    generateSelect = () => {
        return (
            <select onChange={this.props.handler} disabled={true}>
                <option selected value={this.props.userDetails.company ? this.props.userDetails.company.id : ''}>
                    {this.props.placeholder}
                </option>
            </select>
        );
    };
    render() {
        return (
            <div className={`formSelect ${this.props.extraClasses}`}>
                <label>{this.props.label}</label>
                <div className="selectWrapper">{this.generateSelect()}</div>
            </div>
        );
    }
}

export class EditCompanyManagerSelect extends React.Component {
    generateSelect = () => {
        return (
            <select onChange={this.props.handler} disabled={true}>
                <option selected value={this.props.userDetails.company ? this.props.userDetails.company.id : ''}>
                    {this.props.placeholder}
                </option>
            </select>
        );
    };
    render() {
        
        return (
            <div className={`formSelect ${this.props.extraClasses}`}>
                <label>{this.props.label}</label>
                <div className="selectWrapper">{this.generateSelect()}</div>
            </div>
        );
    }
}


// need to see for bugs

export class EditPharmacyAdminSelect extends React.Component {
    generateSelect = () => {
        let isDisabled = false;
        let roleOfRoleSelect = this.props.role;
        let listOfPharmacies = this.props.pharmacyList.pharmacies ? this.props.pharmacyList.pharmacies : this.props.pharmacyList;
        if (roleOfRoleSelect === UserRoleValue.STORE_OWNER) {
            isDisabled = true;
        }
        
        return (
            <select onChange={this.props.handler} disabled={isDisabled} value={this.props.pharmacyId}>
                <option value="">{strings.Select_pharmacy}</option>
                {(listOfPharmacies || []).map(pharmacy => {
                    return (
                        <option key={pharmacy.id} value={pharmacy.id}>
                            {pharmacy.name}
                        </option>
                    );
                })}
            </select>
        );
    };

    render() {
        return (
            <div className={`formSelect ${this.props.extraClasses}`}>
                <label>{this.props.label}</label>
                <div className="selectWrapper">{this.generateSelect()}</div>
            </div>
        );
    }
}

export class EditPharmacyOwnerSelect extends React.Component {
    generateSelect = () => {
        let listOfPharmacies = this.props.pharmacyList.pharmacies ? this.props.pharmacyList.pharmacies : this.props.pharmacyList;

        return (
            <select onChange={this.props.handler} value={this.props.pharmacyId}>
                <option value="">{this.props.selectDefault}</option>
                {(listOfPharmacies || []).map(pharmacy => {
                    return (
                        <option key={pharmacy.id} value={pharmacy.id}>
                            {pharmacy.name}
                        </option>
                    );
                })}
            </select>
        );
    };

    render() {
        return (
            <div className={`formSelect ${this.props.extraClasses}`}>
                <label>{this.props.label}</label>
                <div className="selectWrapper">{this.generateSelect()}</div>
            </div>
        );
    }
}

export class EditPharmacyManagerSelect extends React.Component {
    generateSelect = () => {
        let listOfPharmacies = this.props.pharmacyList.pharmacies ? this.props.pharmacyList.pharmacies : this.props.pharmacyList;

        return (
            <select onChange={this.props.handler} disabled={true}>
                <option value={this.props.userDetails.pharmacy ? this.props.userDetails.pharmacy.id : ''}>{this.props.placeholder}</option>
                {(listOfPharmacies || []).map(pharmacy => (
                    <option key={pharmacy.id} value={pharmacy.id}>
                        {pharmacy.name}
                    </option>
                ))}
            </select>
        );
    };

    render() {
        return (
            <div className={`formSelect ${this.props.extraClasses}`}>
                <label>{this.props.label}</label>
                <div className="selectWrapper">{this.generateSelect()}</div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/customModules/Common/form/Selects-edit.js